export default {
  isPageLoading(context, data) {
    context.commit('IS_PAGE_LOADING', data);
  },
  setOnlineStatus(context, status) {
    context.commit('SET_ONLINE_STATUS', status);
  },
  setNotification({ commit }, data) {
    commit('SET_NOTIFICATION', data);
  },
};
